var map = {
	"./admin_forwarder.css": [
		8530,
		8530
	],
	"./admin_spil.css": [
		9447,
		9447
	],
	"./login_forwarder.css": [
		925,
		925
	],
	"./login_spil.css": [
		4692,
		4692
	],
	"./main.css": [
		7600,
		7600
	],
	"./theme_forwarder.css": [
		6887,
		6887
	],
	"./theme_spil.css": [
		8020,
		8020
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5074;
module.exports = webpackAsyncContext;